module.exports = __webpack_public_path__ + "img/wRatings-2021-GoForTheW-v2.ef29b877.png";